<template>
    <div>
        <voucherSummaryDate v-show="tab == 'date'" ref="voucherSummaryDate" @setSummary="setSummary" @setExportData="setExportData"></voucherSummaryDate>
        <voucherSummaryCustomer v-show="tab == 'customer'" ref="voucherSummaryCustomer" @setCustomerSummary="setCustomerSummary" @setExportData="setExportData"></voucherSummaryCustomer>
        <voucherSummaryVoucher v-show="tab == 'voucher'" ref="voucherSummaryVoucher"  @setExportData="setExportData"></voucherSummaryVoucher>
        <voucherSummaryExpiry v-show="tab == 'expiry'" ref="voucherSummaryExpiry"  @setExportData="setExportData"></voucherSummaryExpiry>
    </div>
</template>
<script>
import VoucherSummaryDate from './Voucher_Summary_Date'
import VoucherSummaryCustomer from './Voucher_Summary_Customer'
import VoucherSummaryVoucher from './Voucher_Summary_Voucher'
import VoucherSummaryExpiry from './Voucher_Summary_Expiry'
export default {
    name: "voucherSummary",
    data(){
        return{
            tab: "date",
        }
    },
    components:{
        VoucherSummaryDate, VoucherSummaryCustomer, VoucherSummaryVoucher, VoucherSummaryExpiry
    },
    methods:{
        async handleVoucherSummary(filterObj){
            this.tab = filterObj.summaryType
            if(this.tab == 'date'){
                this.$refs.voucherSummaryDate.setVoucherSummary(filterObj);
            }else if(this.tab == 'voucher'){
                await this.$refs.voucherSummaryVoucher.setVoucherSummaryVoucher(filterObj);
            }else if(this.tab == 'customer'){
                await this.$refs.voucherSummaryCustomer.setVoucherSummaryCustomer(filterObj);
            }else if(this.tab == 'expiry'){
                await this.$refs.voucherSummaryExpiry.setVoucherSummaryExpiry(filterObj);
            }
        }, 
        setSummary(data){
            this.$emit('setSummary', data)
        },
        setCustomerSummary(data){
            this.$emit('setCustomerSummary', data)
        },
        setBalanceSummary(total){
            this.$emit('setBalanceSummary', total)
        },
        setExportData(data){
            this.$emit('setExportData', data)
        }
    }
}
</script>
